module.exports = __webpack_public_path__ + "static/media/B2.2e64e05a.svg";